"use client";

import { HamburgerMenuButton } from "@/components/ui/HamburgerMenuButton";
import { cn } from "@/lib/utils";
import { InAppNotificationPopover } from "./_in-app-notifications/InAppNotificationPopover";
import { MemberAccountActionMenu } from "./MemberAccountActionMenu";

export const sideMenuToggleButtonId = "side-menu-toggle-button";

export const MembersHeader = ({
  relatedOfficeName,
  memberName,
  sideMenuOpened,
  toggleSideMenuOpened,
}: {
  relatedOfficeName: string;
  memberName: string;
  sideMenuOpened: boolean;
  toggleSideMenuOpened: () => void;
}) => {
  return (
    <div
      className={cn(
        "flex h-20 w-full flex-row items-center justify-between border-b border-b-monotone-1 p-4",
        "lg:p-6",
      )}
    >
      <div className="flex flex-row items-center gap-2 lg:gap-0">
        <HamburgerMenuButton
          id={sideMenuToggleButtonId}
          open={sideMenuOpened}
          onClick={() => {
            toggleSideMenuOpened();
          }}
          className="lg:hidden"
        />
        <div className="font-bold">{relatedOfficeName}</div>
      </div>
      <div className="flex items-center gap-4">
        <InAppNotificationPopover />
        <MemberAccountActionMenu userName={memberName} />
      </div>
    </div>
  );
};
